import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createExtensionSuccess } from 'src/app/pages/add-extension/state/add-extension.actions';
import { saveExtensionDetailSuccess } from 'src/app/pages/extension-details/state/extension-detail.actions';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterExtensionOption } from '../../select/shared/filter-extension-option';
import { extensionOptionActions } from './extension-option.actions';

export const extensionOptionFeatureKey = 'extensionOptions';

export type ExtensionOptionState = EagerSelectState<ExtensionOption>;

const adapter = createEagerSelectAdapter<ExtensionOptionState, ExtensionOption>({
   featureKey: extensionOptionFeatureKey,
   selectId: (extension: ExtensionOption) => {
      return extension.extensionId;
   },
});

export const extensionOptionSelectors = adapter.getSelectors(filterExtensionOption);

const initialState = adapter.getInitialState();

export const extensionOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   extensionOptionActions.search,
   extensionOptionActions.searchReset,
   extensionOptionActions.loadFromApi,
   extensionOptionActions.loadFromApiSuccess,
   extensionOptionActions.loadFromApiFailure,
   null,
   on(createExtensionSuccess, saveExtensionDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
